export const DROPDOWN_MAX_HEIGHT = 224;
export const DROPDOWN_MAX_HEIGHT_M2 = 160;
